// @core/api/endpoints/chat/search_messages.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchMessagesResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Search messages
 * Full-text search across messages in conversations the user is a member of. Supports filtering by conversation, sender, date range, and content type. Returns messages with surrounding context.
 */
export async function SearchMessages(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<SearchMessagesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/messages/search`;
  const requestOptions = options;
  return client.get<SearchMessagesResponse>(requestPath, { ...requestOptions, params });
}
